import { z } from 'zod';

const base = {
  startDate: z.date({
    // @ts-ignore
    required_error: 'Start date is required.',
  }),
  endDate: z.date().optional(),
  description: z.string().optional(),
};

export const workExperienceFormSchema = z.object({
  title: z
    .string()
    .min(2, {
      message: 'Title must be at least 2 characters.',
    })
    .max(50, {
      message: 'Title must not be longer than 50 characters.',
    }),
  location: z
    .string()
    .min(2, { message: 'Location must be at least 2 characters.' })
    .max(50, {
      message: 'Location must not be longer than 50 characters.',
    }),
  employer: z
    .string()
    .min(2, {
      message: 'Company name must be at least 2 characters.',
    })
    .max(50, {
      message: 'Company name must not be longer than 50 characters.',
    }),
  ...base,
});

export const educationsFormSchema = z.object({
  degree: z
    .string()
    .min(2, {
      message: 'Degree must be at least 2 characters.',
    })
    .max(50, {
      message: 'Degree must not be longer than 50 characters.',
    }),
  institution: z
    .string()
    .min(2, {
      message: 'Institution name must be at least 2 characters.',
    })
    .max(50, {
      message: 'Institution name must not be longer than 50 characters.',
    }),
  fieldOfStudy: z
    .string()
    .min(2, { message: 'Field of study must be at least 2 characters.' })
    .max(50, {
      message: 'Field of study must not be longer than 50 characters.',
    }),
  ...base,
});

export const certificationsFormSchema = z.object({
  name: z
    .string()
    .min(2, {
      message: 'Degree must be at least 2 characters.',
    })
    .max(50, {
      message: 'Degree must not be longer than 50 characters.',
    }),
  issuer: z
    .string()
    .min(2, {
      message: 'Institution name must be at least 2 characters.',
    })
    .max(50, {
      message: 'Institution name must not be longer than 50 characters.',
    }),
  sourceUrl: z.string().url().optional(),
  issueDate: z.date({
    // @ts-ignore
    required_error: 'Issue date is required.',
  }),
  expirationDate: z.date().optional(),
  description: z.string().optional(),
});

export const careerSettingsFormSchema = z.object({
  currentRole: z
    .string()
    .min(2, {
      message: 'Current role/position must be at least 2 characters.',
    })
    .max(50, {
      message: 'Current role/position must not be longer than 50 characters.',
    }),
  targetRole: z.string().optional(),
  currentLevel: z
    .string()
    .min(2, {
      message: 'Current level must be at least 2 characters.',
    })
    .max(50, {
      message: 'Current level must not be longer than 50 characters.',
    }),
  areasOfInterest: z.string().optional(),
  targetLevel: z.string().optional(),
  goalTimeframe: z.string().optional(),
  goalDescription: z.string().optional(),
});

export const profileFormSchema = z.object({
  firstName: z
    .string()
    .min(2, {
      message: 'First name must be at least 2 characters.',
    })
    .max(50, {
      message: 'First name must not be longer than 50 characters.',
    }),
  lastName: z
    .string()
    .min(2, {
      message: 'Last name must be at least 2 characters.',
    })
    .max(50, {
      message: 'Last name must not be longer than 50 characters.',
    }),
  address: z.string().optional(),
  title: z.string().optional(),
  bio: z.string().optional(),
});
